import React from 'react';

import CreateContacts from '../../creates/contacts/Customer';
import Contact from './Contact';

function Contacts({
  data,
  customerId,
  RefreshPage,
}: {
  data: Array<CustomerContact>;
  customerId: Number;
  RefreshPage: Function;
}) {
  return (
    <>
      <CreateContacts customerId={customerId} RefreshPage={RefreshPage} />
      {data?.map((individual, index) => (
        <React.Fragment key={index}>
          <Contact individual={individual} RefreshPage={RefreshPage} />
        </React.Fragment>
      ))}
    </>
  );
}
export default Contacts;
